import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"64px","padding":"15px 15px","display":"flex","justify-content":"center"} }, [
  /*#__PURE__*/_createElementVNode("img", {
    style: {"display":"flex","max-width":"100%","max-height":"100%","height":"100%","object-fit":"contain"},
    src: "https://klleon-media-dev.s3.amazonaws.com/media/public/klleon_saas__previewer/image/720/image-e6c028dc-4c54-418f-a768-90e06bed2cae.png"
  })
], -1)
const _hoisted_2 = { style: {"font-size":"16px"} }
const _hoisted_3 = { style: {"display":"flex","justify-content":"space-between"} }
const _hoisted_4 = { style: {"margin-right":"5px"} }
const _hoisted_5 = { style: {"display":"flex","justify-content":"space-between"} }
const _hoisted_6 = { style: {"margin-top":"24px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_sub_menu = _resolveComponent("a-sub-menu")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_layout_sider = _resolveComponent("a-layout-sider")!
  const _component_menu_unfold_outlined = _resolveComponent("menu-unfold-outlined")!
  const _component_menu_fold_outlined = _resolveComponent("menu-fold-outlined")!
  const _component_setting_outlined = _resolveComponent("setting-outlined")!
  const _component_a_layout_header = _resolveComponent("a-layout-header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_layout = _resolveComponent("a-layout")!

  return (_openBlock(), _createBlock(_component_a_layout, null, {
    default: _withCtx(() => [
      _createVNode(_component_a_layout_sider, {
        collapsed: _ctx.collapsed,
        "onUpdate:collapsed": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.collapsed) = $event)),
        breakpoint: "xl",
        "collapsed-width": "60",
        trigger: null,
        width: 250,
        collapsible: ""
      }, {
        default: _withCtx(() => [
          _hoisted_1,
          _createVNode(_component_a_menu, {
            "selected-keys": _ctx.selectedKeys,
            "onUpdate:selected-keys": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedKeys) = $event)),
            openKeys: _ctx.openKeys,
            "onUpdate:openKeys": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.openKeys) = $event)),
            theme: "dark",
            mode: "inline"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getTabMenu, (menu) => {
                return (_openBlock(), _createBlock(_component_a_sub_menu, {
                  key: menu.label
                }, {
                  title: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menu.icons, (icon, index) => {
                      return (_openBlock(), _createBlock(_resolveDynamicComponent(icon), {
                        key: index,
                        style: {"margin-right":"5px"}
                      }))
                    }), 128)),
                    _createElementVNode("span", _hoisted_2, _toDisplayString(menu.label), 1)
                  ]),
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menu.children, (child) => {
                      return (_openBlock(), _createBlock(_component_a_menu_item, {
                        key: child.name,
                        onClick: ($event: any) => (_ctx.$router.push({ path: child.path }))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("span", _hoisted_4, _toDisplayString(child.label), 1),
                            _createElementVNode("div", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(child.icons, (icon, index) => {
                                return (_openBlock(), _createBlock(_resolveDynamicComponent(icon), { key: index }))
                              }), 128))
                            ])
                          ])
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    }), 128))
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }, 8, ["selected-keys", "openKeys"])
        ]),
        _: 1
      }, 8, ["collapsed"]),
      _createVNode(_component_a_layout, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_layout_header, { style: {"background":"#fff","padding":"0 16px"} }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", null, [
                  (_ctx.collapsed)
                    ? (_openBlock(), _createBlock(_component_menu_unfold_outlined, {
                        key: 0,
                        class: "trigger",
                        onClick: _cache[3] || (_cache[3] = () => (_ctx.collapsed = !_ctx.collapsed))
                      }))
                    : (_openBlock(), _createBlock(_component_menu_fold_outlined, {
                        key: 1,
                        class: "trigger",
                        onClick: _cache[4] || (_cache[4] = () => (_ctx.collapsed = !_ctx.collapsed))
                      }))
                ]),
                _createElementVNode("div", null, [
                  _createVNode(_component_setting_outlined, { class: "trigger" })
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_a_layout_content, {
            style: _normalizeStyle({
          margin: '24px 16px',
          padding: '0 24px',
          background: '#fff',
          height: 'calc(100vh - 64px - 48px)',
          overflow: 'auto',
        })
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_router_view)
              ])
            ]),
            _: 1
          }, 8, ["style"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}